import React, { useEffect } from "react";
import { Form, InputNumber } from "antd";

function Decimal({
  form,
  textColor,
  name,
  min,
  max,
  controlHeight = 40,
  label,
  width,
  required,
  errorMessage,
  validateFunction,
  labelCol,
  defaultValue,
  placeholder,
  disabled,
  onChange,
}) {

  useEffect(() => {
    form.setFieldsValue({ [name]: defaultValue });
  }, []);

  return (
    <Form.Item
      name={name}
      label={label}
      labelCol={{ span: labelCol ? labelCol : 8 }}
      style={{ width: width, fontWeight: 600 }}
      rules={[
        {
          required: required,
          message: errorMessage,
        },
        () => ({
          validator(_, value) {
            if (required && !value?.toString()) {
              return Promise.reject(errorMessage);
            };
            if (min?.val?.toString()) {
              if (value < min?.val) {
                return Promise.reject(min?.errorMessage);
              }
            }
            if (max?.val?.toString()) {
              if (value > max?.val) {
                return Promise.reject(max?.errorMessage);
              }
            }

            return Promise.resolve();
          },
        }),
      ]}
    >
      <InputNumber
        disabled={disabled}
        onChange={onChange ? onChange : () => { }}
        step={0.1}
        style={{ width: "100%", backgroundColor: "#fff", fontWeight: 600, height: controlHeight, color: textColor }}
        //  defaultValue={defaultValue}
        placeholder={placeholder}
      />
    </Form.Item>
  );
}

export default Decimal;